/******************************************
 * emartmall
 *
 * @author          Luke.kim
 * @copyright       Copyright (c) 2013 emart.
 * @license         This is dual licensed under the MIT and GPL licenses.
 * @version         0.6
 * @description     수정시에는 modify 태그에 수정부분에 대한 설명을 적을것, 코드 수정 이후에는 수정자가 코드 품질 보장.
 * @since           2013-08-29 15:01
 * @modify          2013-11-04 10:20
 * @history         0.2 ScrollTo 추가
 *
 ******************************************/
(function ($, window, document) {

    'use strict';

    var pluginName = 'scroller',
        defaults = {
            bActivateOnload: true,
            bUseHScroll: false,
            bUseVScroll: true,
            bUseMomentum: true,
            nHeight: 0,
            nWidth: 0,
            sClassPrefix: 'scroll_',
            //bUseCss3d : oSupport.bUseCss3d,
            bUseCss3d: false,
            bUseTranslate: true,
            bAutoResize: true,
            elScrollList: 'ul li',
            bAutoFocus: false,
            fnComplete: null,

            /* 대용량 옵션 */
            sListElement: '',
            nRatio: 1.5,
            /* 스크롤바 옵션 */
            bUseScrollbar: false,
            nScrollbarHideThreshold: 0,
            bUseFixedScrollbar: false,
            sScrollbarBorder: "1px solid white",
            sScrollbarColor: "#8e8e8e",
            bUseScrollBarRadius: true,

            /* PullDown/PullUp 옵션 */
            bUsePullDown: false,
            bUsePullUp: false,
            fnPullDownIdle: null,
            fnPullDownBeforeUpdate: null,
            fnPullDownUpdating: null,
            fnPullUpIdle: null,
            fnPullUpBeforeUpdate: null,
            fnPullUpUpdating: null
        };

    function Scroller(element, options) {
        this.el = element;
        this.wel = $(element);
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this._aScrollPositionData = [];

        this.init();
    }

    Scroller.prototype = {
        init: function () {
            this._beforeInitScroller();
            this._initScroller();
            this._afterInitScroller();
            this._attachScrollerEvent();
            if($.isFunction(this.options.fnComplete)){
                this.options.fnComplete.call(this);
            }
        },
        _beforeInitScroller: function () {
            if (this.options.nHeight === 0) {
                this.options.nHeight = this._getMaxHeightOfChildren();
            }

            this._setScrollContainerWidth();
            /*if(this.options.nWidth === 0){
             //this.options.nWidth = this._getWidthOfChildren();
             this.options.nWidth =  jindo.$Document().clientSize().width;
             }
             */
        },
        _initScroller: function () {
            this._welScroller = new jindo.m.Scroll(this.el, this.options);
        },
        _afterInitScroller: function () {
            if (this.options.bAutoFocus) {
                this._aScrollPositionData = this._makeScrollPositionData();
            }
        },
        _attachScrollerEvent: function () {
            this._welScroller.attach('afterScroll', $.proxy(this._onAfterScroll, this));
            this._welScroller.attach('beforeScroll', $.proxy(this._onBeforeScroll, this));
            this._welScroller.attach('position', $.proxy(this._onPosition, this));
        },
        _onAfterScroll: function (oCustomEvt) {
            if (this.options.bAutoFocus) {
                var htFocusPosition = this._getFocusPosition(oCustomEvt.nLeft);
                if (htFocusPosition.bChangeFocus) {
                    this._scrollTo(htFocusPosition.nChangeLeft, 0, 100);
                }
            }

            this._triggerEvent(oCustomEvt);
        },
        _onBeforeScroll: function (oCustomEvt) {
            this._triggerEvent(oCustomEvt);
        },
        _onPosition: function (oCustomEvt) {
            this._triggerEvent(oCustomEvt);
        },
        _triggerEvent: function (oCustomEvt) {
            this.wel.trigger(oCustomEvt.sType, [oCustomEvt]);
        },
        _scrollTo: function (nLeft, nTop, nDuration) {
            this._welScroller.scrollTo(nLeft, nTop, nDuration);
        },
        _makeScrollPositionData: function () {
            var htPosition = null,
                nWidth = null,
                nHeight = null,
                nDistanceX = null,
                $this = null,
                $prev = null;

            return this.wel.find(this.options.elScrollList).map(function (i) {
                $this = $(this);
                $prev = $this.prev();
                htPosition = $this.position();
                nWidth = $this.width();
                nHeight = $this.height();

                nDistanceX = ($prev.length > 0) ? htPosition.left - ($prev.position().left + $prev.width()) : 0;
                //nDistanceX = ($next.length > 0) ? $next.position().left - (htPosition.left + nWidth) : 0;

                return {
                    'nLeft': htPosition.left,
                    'nTop': htPosition.top,
                    'nWidth': nWidth,
                    'nHeight': nHeight,
                    'nCenterLeft': (htPosition.left + nWidth) / 2,
                    'nDistanceX': nDistanceX
                };
            });
        },
        _getWidthOfChildren: function () {
            var nTotalWidth = 0;

            this.wel.find(this.options.elScrollList).parent().children().each(function () {
                nTotalWidth = nTotalWidth + $(this).outerWidth();
            });

            return nTotalWidth;
        },
        _getMaxHeightOfChildren: function () {
            var nMaxHeight = 0;

            this.wel.find(this.options.elScrollList).parent().children().each(function () {
                if ($(this).outerHeight() > nMaxHeight) {
                    nMaxHeight = $(this).outerHeight();
                }
            });

            return nMaxHeight;
        },
        _setScrollContainerWidth: function () {
            this.wel.find('.scroll-container').width(this._getWidthOfChildren());
        },
        _getFocusPosition: function (nScrollLeft) {
            var nLeft = nScrollLeft,
                bChangeFocus = false,
                nAbsoluteLeft = Math.abs(Math.round(nScrollLeft)),
                nNearScrollIdx = null,
                nNearLeft = null,
                nNearDistancex = null;

            $.each(this._aScrollPositionData, function (i, val) {
                if ((val.nLeft < nAbsoluteLeft) && (nAbsoluteLeft < val.nLeft + val.nWidth + val.nDistanceX)) {
                    if (nAbsoluteLeft - val.nLeft < val.nLeft + val.nWidth + val.nDistanceX - nAbsoluteLeft) {
                        nNearScrollIdx = i;
                    } else {
                        nNearScrollIdx = i + 1;
                    }

                    bChangeFocus = true;

                    return false;
                }
            });

            if (nNearScrollIdx !== null && typeof nNearScrollIdx !== "undefined") {
                nNearLeft = this._aScrollPositionData[nNearScrollIdx].nLeft;
                nNearDistancex = this._aScrollPositionData[nNearScrollIdx].nDistanceX;
                nLeft = nNearLeft + (nNearDistancex / 2);
            }

            return {
                bChangeFocus: bChangeFocus,
                nChangeLeft: nLeft
            };

        },
        refresh: function (nHeight) {
            this._welScroller.height(nHeight);
            this._welScroller.refresh();
            this._welScroller.scrollTo(0, 0, 0);
        },
        refreshWidth: function (nWidth) {
            this._welScroller.width(nWidth);
            this._welScroller.refresh();
            this._welScroller.scrollTo(0, 0, 0);
        },
        scrollTo: function (htArgs) {
            var htScroll = $.extend({
                nLeft: 0,
                nTop: 0,
                nDuration: 0
            }, htArgs);

            this._scrollTo(htScroll.nLeft, htScroll.nTop, htScroll.nDuration);
        }
    };
    $.fn[pluginName] = function (options, arg) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                    new Scroller(this, options));
            } else if ($.isFunction(Scroller.prototype[options])) {
                $.data(this, 'plugin_' + pluginName)[options](arg);
            }
        });
    };
    //window.Scroller = Scroller;
})(jQuery, window, document);